import Navbar from "../../components/shared/Navbar";
import Footer from "../../components/shared/Footer";
import BreadCrumbProduct from "../../components/detailProduct/BreadCrumbDetailProduct";
import Detail from "../../components/detailProduct/Detail";
import RightBar from "../../components/shared/RightBar";

export default function DetailProduct() {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbProduct></BreadCrumbProduct>
                <Detail></Detail>
            </main>
            <Footer />
        </div>
    )
}